import React from "react";

export function getProductManagementTable(o) {
  return o.map((i) => (
    <>
      <tr>
        <td>{i.organisationName}</td>
        <td>{i.lvAnalysis}</td>
        <td>{i.reports}</td>
      </tr>
    </>
  ));
}
